import React from "react";
import BaseIcon from "../../utils/BaseIcon";

var DocumentGraphicIcon = function DocumentGraphicIcon(props) {
  var iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: iconFill,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.18 0H2.8C1.677 0 .767.91.767 2.033v19.934C.767 23.09 1.677 24 2.8 24h18.4c1.123 0 2.033-.91 2.033-2.033V4.98c0-.548-.221-1.073-.614-1.456L19.6.578C19.22.208 18.71 0 18.18 0zM2.8 1h15.38c.27 0 .529.105.722.293L21.92 4.24c.2.195.312.462.312.74v16.987c0 .57-.462 1.033-1.033 1.033H2.8c-.57 0-1.033-.463-1.033-1.033V2.033C1.767 1.463 2.229 1 2.8 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.046 16.867a.5.5 0 01.09.992l-.09.008H5.913a.5.5 0 01-.09-.992l.09-.008h6.133zm6.133-4.6a.5.5 0 01.09.992l-.09.008H5.913a.5.5 0 01-.09-.992l.09-.008h12.266zm0-4.6a.5.5 0 01.09.992l-.09.008H5.913a.5.5 0 01-.09-.992l.09-.008h12.266z"
  }))));
};

DocumentGraphicIcon.displayName = "DocumentGraphicIcon";
DocumentGraphicIcon.defaultProps = {
  size: 48
};
DocumentGraphicIcon.displayName = "DocumentGraphicIcon";
DocumentGraphicIcon.iconName = "Document";
export default DocumentGraphicIcon;